import classNames from '@/lib/misc/classNames';
import { FaArrowLeft } from 'react-icons/fa';
import { useScreen } from 'usehooks-ts';
interface NumberPadProps {
  className?: string;
  value: string;
  tokenAmountToSend: string;
  onValueChange: (_: string) => void;
  handleNumPadTokenChange: (_: string) => void;
  isSwitched: boolean;
}
export default function NumberPad({
  className,
  value,
  tokenAmountToSend,
  onValueChange,
  handleNumPadTokenChange,
  isSwitched
}: NumberPadProps) {
  const realValue = isSwitched ? tokenAmountToSend : Number(value)?.toFixed(2);
  const handleClickNumPad = (pad: string) => {
    const currentValue = isSwitched ? tokenAmountToSend : value;
    if (pad === '.' && currentValue?.includes('.')) {
      return;
    }
    const newValue = currentValue === '0' && pad !== '.' ? pad : currentValue + pad;
    if (isSwitched) {
      handleNumPadTokenChange(newValue);
    } else {
      onValueChange(newValue);
    }
  };
  const handleClickDelete = () => {
    const currentValue = isSwitched ? tokenAmountToSend : value;
    const newValue = currentValue.length === 1 ? '0' : currentValue.slice(0, -1);
    if (isSwitched) {
      handleNumPadTokenChange(newValue);
    } else {
      onValueChange(newValue);
    }
  };
  const width = useScreen().width;
  const height = useScreen().height;
  return <div className={classNames('w-full px-2 py-6 flex flex-col text-[1.3rem]  ', className, height < 800 && 'text-[1rem] my-2', height < 700 && 'text-[1rem] my-2')} data-sentry-component="NumberPad" data-sentry-source-file="NumberPad.tsx">
      <div className='w-full flex items-center gap-x-12 '>
        <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('1')}>
          {1}
        </div>
        <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('2')}>
          {2}
        </div>
        <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('3')}>
          {3}
        </div>
      </div>
      <div className='w-full flex items-center gap-x-12'>
        <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('4')}>
          {4}
        </div>
        <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('5')}>
          {5}
        </div>
        <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('6')}>
          {6}
        </div>
      </div>
      <div className='w-full flex items-center gap-x-12'>
        <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('7')}>
          {7}
        </div>
        <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('8')}>
          {8}
        </div>
        <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('9')}>
          {9}
        </div>
      </div>
      <div className='w-full flex items-center gap-x-12'>
        <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('.')}>
          {'.'}
        </div>
        <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('0')}>
          {0}
        </div>
        <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4 flex items-center justify-center' onClick={() => handleClickDelete()}>
          <FaArrowLeft data-sentry-element="FaArrowLeft" data-sentry-source-file="NumberPad.tsx" />
        </div>
      </div>
    </div>;
}